export const getTimestampMillis = (value) => {
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (typeof value?.toDate === "function") return value.toDate().getTime();

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

export const getMessagePreview = (conversation) => {
  if (conversation?.lastMessage) return String(conversation.lastMessage);

  const previews = {
    audio: "Mensaje de voz",
    image: "Imagen",
    file: "Archivo adjunto",
  };

  return previews[conversation?.lastMessageType] || "Tienes un mensaje nuevo";
};

export const shouldNotifyConversation = ({
  conversation,
  userId,
  previousTimestamp = 0,
  activeConversationId = "",
  documentVisible = true,
}) => {
  if (!conversation || !userId) return false;
  if (conversation.lastSenderId === userId) return false;
  if (!conversation.unreadBy?.includes(userId)) return false;

  const timestamp = getTimestampMillis(conversation.timestamp);
  if (!timestamp || timestamp <= previousTimestamp) return false;

  return !(
    documentVisible &&
    activeConversationId &&
    activeConversationId === conversation.id
  );
};
